
export const ADS_MainCategoryCode = [
    { id: 0, title: "همه" },
    { id: 1, title: "املاک" },
    { id: 2, title: "آهن و فلزات" },
    { id: 3, title: "مصالح ساختمانی" },
    { id: 4, title: "ماشین آلات و ابزار" },
    { id: 5, title: "تاسیسات و تجهیزات" },
    { id: 6, title: "خدمات و نیرو کار ساختمانی" },
    { id: 7, title: "معمار و پیمان کار" },
]
export const ADS_PropertyTypeCode = [
    { id: 0, title: "همه" },
    { id: 1, title: "آپارتمان مسکونی" },
    { id: 2, title: "آپارتمان اداری" },
    { id: 3, title: "خانه و ویلا" },
    { id: 4, title: "زمین و کلنگی" },
    { id: 5, title: "مستغلات" },
    { id: 6, title: "مغازه" },
    { id: 7, title: "صنعتی و کشاورزی" },
]

export const ADS_PropertyTradeTypeCode = [
    { id: 0, title: "همه" },
    { id: 1, title: "فروش" },
    { id: 2, title: "رهن و اجاره" },
    { id: 3, title: "معاوضه" },
    { id: 4, title: "مشارکت در ساخت" },
    { id: 5, title: "پبش فروش" },
    { id: 6, title: "رهن و اجاره کوتاه مدت" },
    { id: 7, title: "متقاضی خرید" },
    { id: 8, title: "متقاضی اجاره" },
]





export const filtersItemCategory = [
    {
        id: 1,
        title: "دسته بندی آگهی",
        subs: [
            { id: 0, masterId: 1, title: "همه" },
            { id: 1, masterId: 1, title: "املاک" },
            { id: 2, masterId: 1, title: "آهن و فلزات" },
            { id: 3, masterId: 1, title: "مصالح ساختمانی" },
            { id: 4, masterId: 1, title: "ماشین آلات و ابزار" },
            { id: 5, masterId: 1, title: "تاسیسات و تجهیزات" },
            { id: 6, masterId: 1, title: "خدمات و نیرو کار ساختمانی" },
            { id: 7, masterId: 1, title: "معمار و پیمان کار" },
        ]
    },
]
export const filtersItemTypeMoamele = [
    {
        id: 10,
        title: "نوع معامله",
        subs: [
            { id: 0, masterId: 10, title: "همه" },
            { id: 1, masterId: 10, title: "فروش" },
            { id: 2, masterId: 10, title: "رهن و اجاره" },
            { id: 3, masterId: 10, title: "معاوضه" },
            { id: 4, masterId: 10, title: "مشارکت در ساخت" },
            { id: 5, masterId: 10, title: "پیش فروش" },
            { id: 6, masterId: 10, title: "رهن و اجاره کوتاه مدت" },
            { id: 7, masterId: 10, title: "متقاضی خرید" },
            { id: 8, masterId: 10, title: "متقاضی اجاره" },
        ]
    }
]

export const filterOptions = [


    { id: 21, title: "پارکینگ" },
    { id: 22, title: "انباری" },
    { id: 23, title: "آسانسور" },


]
export const orderType = [
    {
        id: 24,
        title: "نوع آگهی",
        subs: [
            { id: 25, masterId: 24, title: "همه" },
            { id: 26, masterId: 24, title: "عادی" },
            { id: 27, masterId: 24, title: "حراجی" },
        ]
    }
]

export const housesCategory = [
    { id: 1, img: "/icons/category1-1.svg" },
    { id: 2, img: "/icons/category2-2.svg" },
    { id: 3, img: "/icons/category3-3.svg" },
    { id: 4, img: "/icons/category4-4.svg" },
    { id: 5, img: "/icons/category5-5.svg" },
    { id: 6, img: "/icons/category6-6.svg" },
    { id: 7, img: "/icons/category7-7.svg" },
    { id: 8, img: "/icons/category8-8.svg" },
]

export const filtersItemTypeMelk = [
    {
        id: 28,
        title: "نوع ملک",
        subs: [
            { id: 0, masterId: 28, title: "همه" },
            { id: 1, masterId: 28, title: "آپارتمان مسکونی" },
            { id: 2, masterId: 28, title: "آپارتمان اداری" },
            { id: 3, masterId: 28, title: "خانه و ویلا" },
            { id: 4, masterId: 28, title: "زمین و کلنگی" },
            { id: 5, masterId: 28, title: "مستغلات" },
            { id: 6, masterId: 28, title: "مغازه" },
            { id: 7, masterId: 28, title: "صنعتی و کشاورزی" },
        ]
    }
]

